import React from 'react';
import { Input } from '@/components/ui/input';
import type { FilterDefinition } from '../types';

export interface FilterBarProps {
  filters: FilterDefinition[];
  onFilterChange: (id: string, value: any) => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({ filters, onFilterChange }) => (
  <div className="p-4 bg-gray-50 border-b border-gray-200 flex items-center gap-4">
    {filters.map((filter) => (
      <div key={filter.id}>
        <label className="text-sm font-medium mr-2">{filter.label}</label>
        {/* Simplified filter bar - a real one would have different inputs based on filter.type */}
        <Input
          placeholder={`Filter by ${filter.label}...`}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onFilterChange(filter.id, e.target.value)}
          className="w-48"
        />
      </div>
    ))}
  </div>
);
